import { IGetInspecaoObraByIdUseCase } from "../../../presentation/useCases/read/get_inspecao_obra_by_id_use_case";
import { InspecaoObraDetalhes } from "../../models/inspecao_obra_detalhes";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetInspecaoObraByIdUseCase
 */

export class GetInspecaoObraByIdUseCase implements IGetInspecaoObraByIdUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getInspecaoObraById(
    idInspecaoObra: number | undefined,
  ): Promise<InspecaoObraDetalhes> {
    if (idInspecaoObra === undefined) throw new Error('Id de inspeção de obra invalido!');
    const response = await this.repository.getInspecaoObraById(idInspecaoObra);
    if (response === null) throw new Error('Falha ao buscar inspeção de obra!');
    return response;
  }
}
